import { render, staticRenderFns } from "./GioiThieuList.vue?vue&type=template&id=9989f78a"
import script from "./GioiThieuList.vue?vue&type=script&lang=js"
export * from "./GioiThieuList.vue?vue&type=script&lang=js"
import style0 from "./GioiThieuList.vue?vue&type=style&index=0&id=9989f78a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports